module.exports = __webpack_public_path__ + "static/media/under_construction1.e55a348e.png";